import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  IconButton,
  Collapse,
  Box,
} from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
export const DynamicTable = ({ columns, rows }) => {
  const [orderBy, setOrderBy] = useState(columns[0]?.field || ""); // Columna inicial para ordenar
  const [orderDirection, setOrderDirection] = useState("asc");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [expandedRows, setExpandedRows] = useState({}); // Estado para manejar filas abiertas

  // Función para ordenar los datos dinámicamente
  const handleSort = (column) => {
    const isAsc = orderBy === column && orderDirection === "asc";
    setOrderBy(column);
    setOrderDirection(isAsc ? "desc" : "asc");

    rows.sort((a, b) => {
      if (a[column] < b[column]) return isAsc ? -1 : 1;
      if (a[column] > b[column]) return isAsc ? 1 : -1;
      return 0;
    });
  };

  // Cambiar página
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Cambiar cantidad de filas por página
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Manejar expansión de filas
  const toggleRow = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left" /> {/* Espacio para el botón de expansión */}
              {columns.map((col) => (
                <TableCell key={col.field} align="start">
                  <TableSortLabel
                    active={orderBy === col.field}
                    direction={orderBy === col.field ? orderDirection : "asc"}
                    onClick={() => handleSort(col.field)}
                  >
                    {col.label}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>


          <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
                {/* Fila principal */}
                <TableRow>
                  <TableCell>
                    {row.configSubColumns ? (
                      <IconButton onClick={() => toggleRow(rowIndex)} size="small">
                        {expandedRows[rowIndex] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                      </IconButton>
                    ) : null}
                  </TableCell>
                  {columns.map((col) => (
                    <TableCell key={`${rowIndex}-${col.field}`}>
                      {typeof row[col.field] === "function" ? row[col.field]() : row[col.field]}
                    </TableCell>
                  ))}
                </TableRow>

                {/* Renderización Recursiva de Subtablas */}
                {row.configSubColumns && (
                  <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={columns.length + 1} align="left">
                      <Collapse in={expandedRows[rowIndex]} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                          <DynamicTable
                            columns={row.configSubColumns.columns}
                            rows={row.configSubColumns.rows}
                          />
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                )}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Paginación */}
      <TablePagination
        labelRowsPerPage={"Filas por página"} 
        rowsPerPageOptions={[5, 10, 15]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};
